import React, { useMemo, useState } from 'react';
import { Col, DatePicker, Button, Select, Space } from 'antd';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/financialOverview.linkstate';
import moment from 'moment-timezone';

const { RangePicker } = DatePicker;
const { Option } = Select;

// Add props
interface FinancialOverviewFilterProps {
    onGenerate?: () => void;
    loading?: boolean;
}

export const FinancialOverviewFilter: React.FC<FinancialOverviewFilterProps> = ({ onGenerate, loading }) => {
    const [{ selectedDateRange }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();
    const [selectedMonth, setSelectedMonth] = useState<string | undefined>();

    const rangePickerValue = useMemo(() => {
        return selectedDateRange?.fromDate && selectedDateRange?.toDate
            ? [moment(selectedDateRange.fromDate), moment(selectedDateRange.toDate)]
            : null;
    }, [selectedDateRange]);

    const handleGenerateClick = () => {
        if (selectedMonth) {
            const start = moment(selectedMonth).startOf('month');
            const end = moment(selectedMonth).endOf('month');
            patchState({
                selectedDateRange: {
                    fromDate: start.format('YYYY-MM-DD'),
                    toDate: end.format('YYYY-MM-DD'),
                },
            });
        }
        onGenerate?.();
    };

    return (
        <Space size="middle" wrap>
            <Col>
                <RangePicker
                    value={rangePickerValue as any}
                    onChange={(dates) =>
                        patchState({
                            selectedDateRange:
                                dates && dates[0] && dates[1]
                                    ? {
                                          fromDate: dates[0].format('YYYY-MM-DD'),
                                          toDate: dates[1].format('YYYY-MM-DD'),
                                      }
                                    : undefined,
                        })
                    }
                />
            </Col>

            <Col>
                <Select
                    placeholder="Select month"
                    allowClear
                    style={{ width: 160 }}
                    value={selectedMonth}
                    onChange={(value) => setSelectedMonth(value)}
                >
                    {Array.from({ length: 12 }).map((_, i) => {
                        const month = moment().month(i);
                        return (
                            <Option key={i} value={month.format('YYYY-MM')}>
                                {month.format('MMMM YYYY')}
                            </Option>
                        );
                    })}
                </Select>
            </Col>

            <Col>
                <Button type="primary" onClick={handleGenerateClick} loading={loading}>
                    Generate
                </Button>
            </Col>
        </Space>
    );
};
